import { Plus, Trash2 } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import FdeSelect from '@/frontend/features/Fde/FdeSelect'
import type { FdeCopy } from '@/frontend/features/Fde/types'

export interface ContractField {
  [key: string]: string | boolean | undefined
  key: string
  label: string
  data_type: string
  required?: boolean
}

interface Props {
  fields: ContractField[]
  onChange: (fields: ContractField[]) => void
  copy: FdeCopy
  title?: string
}

const FIELD_TYPES = ['text', 'long_text', 'email', 'phone', 'url', 'number', 'boolean', 'date']

export default function OntologySchemaFieldEditor({ fields, onChange, copy, title }: Props) {
  function update(index: number, attributes: Partial<ContractField>) {
    onChange(fields.map((field, fieldIndex) => fieldIndex === index ? { ...field, ...attributes } : field))
  }

  function add() {
    onChange([...fields, { key: '', label: '', data_type: 'text', required: false }])
  }

  return (
    <section className="rounded-lg border border-border bg-muted/15 p-3">
      <div className="mb-2 flex items-center justify-between">
        <p className="text-xs font-semibold text-foreground">{title || copy.forms.input_schema}</p>
        <Button type="button" size="sm" variant="ghost" onClick={add}><Plus />{copy.forms.add_schema_field}</Button>
      </div>
      {fields.length === 0 ? null : <div className="space-y-2">
        {fields.map((field, index) => (
          <div key={index} className="grid grid-cols-[minmax(0,0.8fr)_minmax(0,1fr)_8rem_auto_auto] items-center gap-2">
            <Input aria-label={copy.forms.schema_field_key} placeholder={copy.forms.schema_field_key} value={field.key} onChange={(event) => update(index, { key: event.target.value })} />
            <Input aria-label={copy.forms.schema_field_label} placeholder={copy.forms.schema_field_label} value={field.label} onChange={(event) => update(index, { label: event.target.value })} />
            <FdeSelect ariaLabel={copy.forms.schema_field_type} value={field.data_type} onValueChange={(value) => update(index, { data_type: value })} options={FIELD_TYPES.map((type) => ({ value: type, label: copy.forms[`data_type_${type}`] }))} className="text-xs" />
            <label className="flex items-center gap-1.5 whitespace-nowrap text-xs text-muted-foreground"><input type="checkbox" checked={Boolean(field.required)} onChange={(event) => update(index, { required: event.target.checked })} className="size-4 accent-primary" />{copy.forms.schema_field_required}</label>
            <Button type="button" size="icon-sm" variant="ghost" title={copy.common.delete} onClick={() => onChange(fields.filter((_, fieldIndex) => fieldIndex !== index))}><Trash2 /></Button>
          </div>
        ))}
      </div>}
    </section>
  )
}
